<script>
    import {createEventDispatcher, onMount} from "svelte";
    import CloseButton from "./layout/CloseButton.svelte";
    import {focusFirstElement, portal, trapKey} from "../lib/actions.js";

    let className = '';
    export {className as class};
    export let title = 'title';
    export let closesOnEscape = false;
    export let showClose = false;


    let open = false;
    let popup;

    const dispatch = createEventDispatcher();

    export const close = () => {
        if (closesOnEscape === false) {
            return;
        }
        open = false;
        setTimeout(() => {
            dispatch('close');
        }, 200);
    };

    onMount(async () => {
        setTimeout(() => {
            open = true;
        }, 0);
    });
</script>

<div class="fixed inset-0 bg-black bg-opacity-25 z-30" use:portal>
    <div bind:this={popup} class="popup" class:open use:trapKey={{key:'Escape', callback:close}}>
        <div class="flex flex-col min-h-0 border-orange border-solid border-2 bg-bg drop-shadow-xl rounded-lg overflow-hidden">
            <div class="shrink-0 px-xs sm:px-md py-1 bg-orange text-white text-lg font-thin flex justify-between">
                {title}
                {#if showClose}
                    <CloseButton on:click={close}/>
                {/if}
            </div>
            <div class="min-h-0 p-md overflow-y-auto {className}" use:focusFirstElement>
                <slot/>
            </div>
        </div>
    </div>
</div>
<style>
    .popup {
        @apply w-full md:max-w-xl fixed flex flex-col;
        max-height: 100vh;
        max-height: 100dvh;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>
